// libraries
import React from "react";

// components
import { SmartHoldsSections } from "../web-settings";

import { LunchGoal } from "@components/goals-wrapper";
import { SmartHoldSync } from "@components/smart-hold-sync";

// util
import { findGoal, standardGoals } from "@util/goal.util";

// material-ui
import { Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";

// ~-~-~-~-~-~-~-
// Focus Time Settings
// ~-~-~-~-~-~-~-
interface LunchSettingsProps {
  org: any;
}

const useStyles = makeStyles({
  h2: {
    marginBottom: 14,
  },
});

export const LunchSettings = (props: LunchSettingsProps) => {
  const classes = useStyles();

  const hasLunchGoal = !!findGoal(props.org.userGoals, standardGoals.Lunch);

  return (
    <div cw-id={`web-settings-${SmartHoldsSections.LunchHold}`}>
      <Typography variant="h2" className={classes.h2}>
        🍽 Lunch
      </Typography>
      <Typography variant="subtitle1" className="cw-mb-9">
        Clockwise can preserve time for you to take a lunch break every day.{" "}
        <a href={"https://getclockwise.com"} target="_blank">
          Learn more
        </a>
        .
      </Typography>
      <Typography variant="h3">Would you like Clockwise to preserve lunch time for you?</Typography>
      <LunchGoal org={props.org} isWebSettings />
      <div style={{ marginBottom: 60 }} />
      <Typography variant="h3">Schedule time for lunch on your calendar?</Typography>
      <Typography variant="subtitle1" className="cw-mb-5">
        Prevent others from scheduling over your lunch break by allowing Clockwise to block it on
        your shared calendar. Clockwise won't schedule over lunch meetings and you can remove
        individual events if they are not needed.
      </Typography>
      <SmartHoldSync
        smartHoldType={"Lunch"}
        renderMode={"Toggle"}
        org={props.org}
        allowAutoSave={true}
        disabled={!hasLunchGoal}
      />
    </div>
  );
};
